import { useState } from "react";
import * as XLSX from "xlsx";
import styled from "styled-components";
import GreenButton from "../../../../ui/GreenButton.js";




const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 16px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  background-color: transparent;
  transition: transform 0.1s;
  font-size: medium;
  font-weight: bold;
  &:hover {
    transform: scale(1.1);
  }
`;

const Div3 = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Div4 = styled.div`

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;



  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    button {
      align-self: stretch;
      margin-top: 12px;
    }
  }
`;
const H2 = styled.h2`
  font-size: 18px;
  color: #575757;
  margin: 0 0 8px 0;
`;


const ServicosLista = styled.div`
  background-color: #f5f5f5;
  margin: 0px 0 20px 0;
  padding: 15px;
  border-radius: 0px 0px 8px 8px;
`;

const ServicoItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }

  p {
    margin: 4px 0;
    font-size: 16px;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Container2 = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column; // <- força em coluna no mobile
  }
`;



const ServicosWrapper = styled.div`
  max-height: ${({ expandido }) => (expandido ? '500px' : '0')};
  overflow-y: scroll;
  transition: max-height 0.5s ease;
`;
const Div7 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 250px;
  p{
    color: #575757;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

  }
`;
const CustosWrapper = styled.div`
  margin-top: 8px;
  margin-left: 20px;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-left: 4px solid #E0F0FF;
  border-radius: 6px;

  ul {
    margin: 0;
    padding: 0;
    list-style: inside;
  }

  li {
    margin-bottom: 4px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 2px solid #ccc;

  span {
    user-select: none;
  }
`;




const Grid = ({ listaObjetoCusto, listaObjetoCustoMes, listaObjetoCustoMesContrato }) => {




  const [osExpandida, setOsExpandida] = useState(null);
  const [parcelaExpandida, setParcelaExpandida] = useState(null);


  //===========================================================================================Ordenar a tabela
  const [sortConfig, setSortConfig] = useState({ key: 'COD_OBJETOCUSTO', direction: 'asc' });
  const sortedLista = [...listaObjetoCusto].sort((a, b) => {
    const { key, direction } = sortConfig;

    let aVal = a[key];
    let bVal = b[key];

    if (key === 'TOTAL_OBJETOCUSTO') {
      // ordenar como número
      aVal = Number(aVal);
      bVal = Number(bVal);
    }

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };



  //===========================================================================================Exportar EXCEL
  const exportarParaExcelObPorMes = () => {
    const linhas = [];

    sortedLista.forEach((objeto) => {
      // Linha do objeto de custo
      linhas.push([`OB: ${objeto.COD_OBJETOCUSTO} - ${objeto.DESC_OBJETOCUSTO}`]);
      linhas.push([`Total do Objeto`, Number(objeto.TOTAL_OBJETOCUSTO)]);
      linhas.push([]); // linha em branco

      // Mapeia meses daquele objeto
      const servicos = listaObjetoCustoMes.filter(
        (s) => s.COD_OBJETOCUSTO === objeto.COD_OBJETOCUSTO
      );

      servicos.forEach((servico) => {
        const mes = new Date(servico.MES_REFERENCIA).toLocaleDateString("pt-BR", {
          month: "2-digit",
          year: "numeric",
        });

        linhas.push([`  Mês: ${mes}`, `Total Mensal`, Number(servico.TOTAL_MENSAL)]);

        const objetosCusto = listaObjetoCustoMesContrato.filter(
          (obj) =>
            obj.COD_OBJETOCUSTO === objeto.COD_OBJETOCUSTO &&
            obj.MES_REFERENCIA === servico.MES_REFERENCIA2
        );

        objetosCusto.forEach((item) => {
          linhas.push([
            `    • ${item.NUMEROCONTRATO} - ${item.DESCRICAORESUMIDA}`,
            `${item.QTDE} x ${Number(item.VLRUNITARIO).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}`,
            Number(item.VLRTOTAL),
          ]);
        });

        linhas.push([]); // espaço entre meses
      });

      linhas.push([]); // espaço entre objetos
    });

    // Cria e exporta o Excel
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(linhas);
    XLSX.utils.book_append_sheet(wb, ws, "Relatório OB x Mês");
    XLSX.writeFile(wb, "central_ti_objetos_por_mes.xlsx");
  };

  return (



    <Container>
      <GreenButton onClick={exportarParaExcelObPorMes}>
        Exportar Excel
      </GreenButton>
      <Div3>
        <HeaderRow>
          <span onClick={() => handleSort("COD_OBJETOCUSTO")} style={{ cursor: 'pointer', flex: 1 }}>
            📅 OB Referência {sortConfig.key === 'COD_OBJETOCUSTO' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span onClick={() => handleSort("TOTAL_OBJETOCUSTO")} style={{ cursor: 'pointer', flex: 1, textAlign: 'right' }}>
            💰 Total Mensal {sortConfig.key === 'TOTAL_OBJETOCUSTO' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span style={{ flex: 0.5, textAlign: 'right' }}>
            🔍 Ações
          </span>
        </HeaderRow>

        {sortedLista.map((item, i) => {
          const objetoCustoMes = listaObjetoCustoMes.filter(
            (p) => p.COD_OBJETOCUSTO === item.COD_OBJETOCUSTO
          );


          return (
            <div key={i}>
              <Div4>


                <H2>OB.: {item.COD_OBJETOCUSTO} - {item.DESC_OBJETOCUSTO}</H2>

                <Div7>
                  <p>
                    <strong>Total:</strong>{" "}
                    {item.TOTAL_OBJETOCUSTO.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                    }
                  </p>
                  <Button onClick={() =>
                    setOsExpandida(prev => prev === item.COD_OBJETOCUSTO ? null : item.COD_OBJETOCUSTO)
                  }>
                    {osExpandida === item.COD_OBJETOCUSTO ? 'Ocultar...' : 'Ver dados...'}
                  </Button>
                </Div7>




              </Div4>

              <ServicosWrapper expandido={osExpandida === item.COD_OBJETOCUSTO}>
                <ServicosLista>
                  {objetoCustoMes.length === 0 ? (
                    <p>Nenhuma informação encontrada.</p>
                  ) : (

                    objetoCustoMes.map((servico, idx) => {
                      const chaveParcela = `${servico.COD_OBJETOCUSTO}-${servico.MES_REFERENCIA}`;

                      const objetosCusto = listaObjetoCustoMesContrato.filter(
                        (obj) =>
                          obj.COD_OBJETOCUSTO === item.COD_OBJETOCUSTO &&
                          obj.MES_REFERENCIA === servico.MES_REFERENCIA2
                      );

                      return (
                        <ServicoItem key={idx}>
                          <Container2>
                            <span>
                              Mês:{" "}
                              {new Date(servico.MES_REFERENCIA).toLocaleDateString("pt-BR", {
                                month: "2-digit",
                                year: "numeric",
                              })}
                            </span>

                            <Div7>
                              <span>
                                {Number(servico.TOTAL_MENSAL).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                })}
                              </span>

                              <Button
                                onClick={() =>
                                  setParcelaExpandida((prev) =>
                                    prev === chaveParcela ? null : chaveParcela
                                  )
                                }
                              >
                                {parcelaExpandida === chaveParcela ? "Ocultar gastos" : "Ver gastos"}
                              </Button>
                            </Div7>
                          </Container2>
                          {parcelaExpandida === chaveParcela && (
                            <CustosWrapper>
                              {objetosCusto.length === 0 ? (
                                <p>Nenhuma informação de custo.</p>
                              ) : (
                                <ul>
                                  {objetosCusto.map((obj, i) => (
                                    <li key={i} style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                      <span>
                                        <strong>{obj.NUMEROCONTRATO}-{obj.DESCRICAORESUMIDA}</strong>:
                                      </span>
                                      <span>
                                        {obj.QTDE} x {" "}
                                        {Number(obj.VLRUNITARIO).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })} ={" "}
                                        {Number(obj.VLRTOTAL).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}
                                      </span>
                                    </li>

                                  ))}
                                </ul>
                              )}
                            </CustosWrapper>
                          )}

                        </ServicoItem>
                      );
                    })


                  )}
                </ServicosLista>
              </ServicosWrapper>


            </div>
          );
        })}

      </Div3>


    </Container>

  );
};


export default Grid;
